import { createSlice, current } from '@reduxjs/toolkit';
import {
	getWorkStatusList,
	getWorkStatus,
	addNewWorkStatus,
	updateWorkStatus,
	deleteWorkStatus,
	checkWorkStatusExists,
} from './thunk';

export const initialState = {
	itemWorkStatusList: [],
	itemWorkStatus: null,
	isWorkStatusLoading: false,
	isWorkStatusSuccess: false,
	dataWorkStatus: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const WorkStatusSlice = createSlice({
	name: 'WorkStatus',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWorkStatusList.pending, state => {
			state.isLoadingList = true;
			state.isWorkStatusSuccess = false;
		});

		builder.addCase(getWorkStatusList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemWorkStatusList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isWorkStatusSuccess = true;
		});

		builder.addCase(getWorkStatusList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWorkStatusSuccess = false;
		});

		builder.addCase(getWorkStatus.pending, state => {
			state.isWorkStatusLoading = true;
			state.isWorkStatusSuccess = false;
		});

		builder.addCase(getWorkStatus.fulfilled, (state, action) => {
			state.itemWorkStatus = action.payload;
			state.isWorkStatusLoading = false;
			state.isWorkStatusSuccess = true;
		});

		builder.addCase(getWorkStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isWorkStatusLoading = false;
			state.isWorkStatusSuccess = false;
		});

		builder.addCase(addNewWorkStatus.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewWorkStatus.fulfilled, (state, action) => {
			state.itemWorkStatusList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewWorkStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateWorkStatus.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateWorkStatus.fulfilled, (state, action) => {
			state.itemWorkStatusList = state.itemWorkStatusList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementList = state.statementList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? { item: action.payload, value: action.payload._id, label: action.payload.name }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(updateWorkStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWorkStatus.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteWorkStatus.fulfilled, (state, action) => {
			state.itemWorkStatusList = current(state.itemWorkStatusList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.statementList = current(state.statementList).filter(
				item => item._id.toString() !== action.payload._id.toString()
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value.toString() !== action.payload._id.toString()
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDeleteError = false;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteWorkStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkWorkStatusExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkWorkStatusExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkWorkStatusExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = WorkStatusSlice.actions;

export default WorkStatusSlice.reducer;
